import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { colors } from 'z-react-components';

export const styles = {
    tickerRow: {
        width: '100%',
        backgroundColor: colors.cyan500
    },
    tickerRowLoggedIn: {
        backgroundColor: colors.white
    },
    tickerContainer: {
        minHeight: 50,
        maxWidth: 1200,
        float: 'none',
        margin: '0 auto',
        marginBottom: 20,
        padding: 15,
        backgroundColor: colors.orange500
    },
    tickerMessage: {
        textAlign: 'center',
        fontWeight: 'bold',
        color: colors.white
    }
};

export default class Ticker extends Component {
    static propTypes = {
        backgroundColor: PropTypes.string,
        fetchTicker: PropTypes.func,
        isLoggedIn: PropTypes.bool,
        tickerMessage: PropTypes.string
    };

    static defaultProps = {
        isLoggedIn: false
    };

    componentWillMount() {
        this.props.fetchTicker();
    }

    render() {
        const { isLoggedIn, tickerMessage, backgroundColor } = this.props;
        return (
            <Row className="cv-ticker" style={{ ...styles.tickerRow, ...(isLoggedIn || backgroundColor ? styles.tickerRowLoggedIn : {}) }}>
                <Col sm={12} style={styles.tickerContainer}>
                    <div style={styles.tickerMessage}>{tickerMessage}</div>
                </Col>
            </Row>
        );
    }
}
